import { CheckoutContextApi } from "./CheckoutProvider.shared";
import { CheckoutSelectedFulfillmentType } from "../..";
import { CheckoutAddress, CheckoutCreditTerms, CheckoutOrder } from "./types";

export const mapToInitialOrder = ({
  order,
  connection,
  fulfillmentType,
}: {
  order: {
    DeliveryAddress: CheckoutAddress;
    deliveryNotes: string;
    purchaseOrderNumber: string;
    InvoiceAddress: CheckoutAddress;
    retailerContactSmsNumber: string;
    paymentTermsRequest: CheckoutCreditTerms;
    hasNoDraughtDutyRelief: boolean;
    distributionContactId?: number;
    price: number;
  };
  connection: CheckoutContextApi["connection"];
  fulfillmentType: CheckoutSelectedFulfillmentType | undefined;
}): CheckoutOrder => {
  return {
    deliveryAddress: order.DeliveryAddress,
    phoneNumber: order.retailerContactSmsNumber,
    deliveryInstructions: order.deliveryNotes,
    deliveryType: fulfillmentType,
    purchaseOrderNumber: order.purchaseOrderNumber,
    invoiceAddress: order.InvoiceAddress,
    draughtDuty: order.hasNoDraughtDutyRelief ? "yes" : "no",
    comment: "",
    payment: {
      type: undefined,
      paymentMethodId: undefined,
    },
    paymentTermsRequest: order.paymentTermsRequest,
    invoiceMethod: "manual-invoice",
    mailingListPermission: connection?.mailingListPermission ?? false,
    distributionContactId: order.distributionContactId,
    timePreference:
      connection?.BuyerSellarDistributionMeta?.timePreference ?? null,
    price: order.price,
    paymentLinkRequested: false,
  };
};
